import React from "react";
import { FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import appFetch from "../../../Utils/Services/Fetch/appFetch";

interface LogoutNavBarProps {
  className?: string;
}

const LogoutNavBar: React.FC<LogoutNavBarProps> = ({ className }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    // The session cookie is HttpOnly, so it must be cleared server-side.
    await appFetch("/api/auth/logout", { method: "POST" });
    navigate("/");
  };

  return (
    <li className={`nav-item ${className}`}>
      <button className="nav-link" onClick={handleLogout}>
        <FaSignOutAlt />
        <span className="link-text">Déconnexion</span>
      </button>
    </li>
  );
};

export default React.memo(LogoutNavBar);
